import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import TextField from '@components/TextFieldCaseSetting';
import Tooltip from '@material-ui/core/Tooltip';
import { withStyles } from '@material-ui/core/styles';
import ImportIcon from '../../../assets/images/list-ol-regular.svg';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import PidImportModal from '@modules/appraisal/components/PidImportModal';
import styled from 'styled-components';

const HtmlTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: '#f5f5f9',
    color: 'white',
    maxWidth: 220,
    fontSize: theme.typography.pxToRem(12),
    border: '1px solid #dadde9',
  },
  popper: {},
}))(Tooltip);

const MultiIdInput = ({
  input,
  title,
  propIdsHistory,
  needHightlight = false,
  canClear = false,
  ...otherProps
}) => {
  const [value, setValue] = useState('');
  const [open, setOpen] = useState(false);
  const [showHistory, setShowHistory] = useState(false);
  const [isInInput, setIsInInput] = useState(false);

  useEffect(() => {
    if (otherProps.meta.initial) {
      handleChange(otherProps.meta.initial.join(', '));
    }
  }, [otherProps.meta.initial]);

  useEffect(() => {
    if (!input.value && value) {
      setValue('');
    }
  }, [input.value]);

  const handleChange = (textValue) => {
    setValue(textValue);
    input.onChange(
      textValue
        .trim()
        .split(/[ ,]+/)
        .filter((item) => item),
    );
  };

  const ids = propIdsHistory
    ? propIdsHistory.filter((hi) => hi.includes(value))
    : [];

  const wrapperProps = {
    'data-ishightlightfromvalue': Boolean(needHightlight && value),
    'data-ishightlightfromprops': needHightlight,
  };

  const handleClear = (event) => {
    event.stopPropagation();
    input.onChange('');
  };

  const getEndAdornment = () => {
    if (!canClear || !value || !value.length) {
      return null;
    }
    return (
      <InputAdornment position="end" style={{ right: 20 }}>
        <IconButton size="small">
          <CloseIcon onClick={handleClear} />
        </IconButton>
      </InputAdornment>
    );
  };

  return (
    <Wrapper {...wrapperProps}>
      <TextField
        {...otherProps}
        {...input}
        inputProps={{
          style: {
            paddingRight: '25px',
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
          },
        }}
        value={value}
        onBlur={() => {
          if (isInInput) {
            return;
          }
          setShowHistory(false);
        }}
        onFocus={() => {
          setShowHistory(true);
        }}
        onChange={(e) => handleChange(e.target.value)}
        style={{ ...otherProps.style, width: '100%' }}
        InputProps={{ endAdornment: getEndAdornment() }}
      />
      <HtmlTooltip
        classes={{ popper: 'custom-arrow-tooltip' }}
        title={
          <div className="tooltip-content">
            {title || 'P'}ID List
            <div className="arrow" />
          </div>
        }
      >
        <i onClick={() => setOpen(true)}>
          <img src={ImportIcon} />
        </i>
      </HtmlTooltip>
      <PidImportModal
        open={open}
        title={title}
        handleClose={(pids = []) => {
          handleChange(pids.filter((i) => !!i).join(','));
          setOpen(false);
        }}
      />
      {ids.length > 0 && showHistory && (
        <HistoryWrapper
          onMouseEnter={() => setIsInInput(true)}
          onMouseLeave={() => setIsInInput(false)}
        >
          {ids.slice(0, 5).map((hi) => (
            <div
              key={hi}
              onClick={() => {
                console.log(hi);
                handleChange(hi);
                setShowHistory(false);
              }}
            >
              {hi}
            </div>
          ))}
        </HistoryWrapper>
      )}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  position: relative;

  i {
    position: absolute;
    right: 0;
    top: 20px;
  }

  .MuiInputBase-input {
    ${(props) =>
      props['data-ishightlightfromvalue'] &&
      `
      background-color: rgba(194, 217, 43, 0.13);
    `}
  }

  .Mui-focused {
    .MuiInputBase-input {
      ${(props) =>
        props['data-ishightlightfromprops'] &&
        `
        background-color: rgba(194, 217, 43, 0.13);
      `}
    }
  }
`;

const HistoryWrapper = styled.div`
  position: absolute;
  width: 100%;
  background: white;
  z-index: 1;
  border: 1px solid #c1c1c1;
  border-radius: 3px;
  box-shadow: 0 1px 2px 0 #888;
  padding: 5px 0;

  & > div {
    padding: 3px 10px;
    cursor: default;

    &:hover {
      background-color: #c8c8c9;
    }
  }
`;

MultiIdInput.propTypes = {
  input: PropTypes.object,
  title: PropTypes.any,
  otherProps: PropTypes.any,
  needHightlight: PropTypes.bool,
  propIdsHistory: PropTypes.array,
  canClear: PropTypes.bool,
};

export default MultiIdInput;
